import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { CommonModalProps } from '../types/common.types';

const CommonModal: React.FC<CommonModalProps> = ({
  open,
  title,
  onClose,
  children,
  maxWidth = 'sm',
  fullWidth = true,
  actions,
  titleActions,
  paperSx,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth} PaperProps={paperSx ? { sx: paperSx } : undefined}>
      <DialogTitle sx={{ pr: 7 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5, flexWrap: 'wrap', pr: 4 }}>
          <Box component="span">{title}</Box>
          {titleActions ? <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>{titleActions}</Box> : null}
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 10, top: 10 }}
        >
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </Dialog>
  );
};

export default CommonModal;
